var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H2.00002C0.879984 0 0 0.879984 0 2.00002V22C0 23.12 0.879984 24 2.00002 24H11.2H16H22C23.12 24 24 23.12 24 22V2.00002C24 0.879984 23.12 0 22 0ZM12 23.2V15.2H8.79998V12H12V9.20002C12 6.92002 13.76 5.00002 16 4.8H19.6V8.00002H16.4C15.72 8.00002 15.2 8.52 15.2 9.20002V12H19.2V15.2H15.2V23.2H12V23.2ZM23.2 22C23.2 22.68 22.68 23.2 22 23.2H16V16H20V11.2H16V9.19997C16 8.95997 16.16 8.79998 16.4 8.79998H20.4V3.99998H15.96C13.28 4.23998 11.2 6.51998 11.2 9.19997V11.2H7.99997V16H11.2V23.2H2.00002C1.32 23.2 0.800016 22.68 0.800016 22V2.00002C0.800016 1.32 1.32 0.800016 2.00002 0.800016H22C22.68 0.800016 23.2 1.32 23.2 2.00002V22H23.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFooter);
export default __webpack_public_path__ + "static/media/facebook-footer.354d4113.svg";
export { ForwardRef as ReactComponent };